import { AdBreakType } from '../../../enums';

export interface AdBreakTypeOption {
  id: AdBreakType;
  name: string;
}

export const adBreakTypeOptions: AdBreakTypeOption[] = [
  { id: AdBreakType.BetweenContentOrAtAdCueMarker, name: 'In between content or at ad cue marker' },
  { id: AdBreakType.AdsPerHour, name: 'Ad Minutes Per Hour' },
  { id: AdBreakType.DragAndDropAdBreak, name: 'Drag & Drop Ad Break' },

];
